import { Button, Grid, Skeleton, Stack, SvgIcon, Typography } from '@mui/material';
import React, { useEffect } from 'react';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useLocation, useNavigate } from 'react-router';
import { paths } from 'src/paths';
import { useDispatch, useSelector } from 'react-redux';
import { getMdsTypeAction } from 'src/redux/actions/mdsCommunicationActions';
import ListingTable from 'src/sections/dashboard/patients/patient-details-listing-table';
import { reFormsMdsCommunicationTreatment } from 'src/config';
import useFeatureToggle from 'src/hooks/use-feature-toggle';

type MdsType = {
  assessmentDate: string;
  assessmentType: string;
};

function MdsCreateTable() {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const { patients, patientDetails, mdsCommunication, addMdsCommunication } = paths;
  const { patientId, patientData } = location.state;
  const getMdsTypeData = useSelector((state: any) => state.getMdsTypeReducer);
  const preFillUrl = useSelector((state: any) => state.getMdsFormIdReducer);
  const getMdsReformIdReducer = useSelector((state: any) => state.getMdsReformIdReducer);
  const [reFormsMdsEnabled] = useFeatureToggle(reFormsMdsCommunicationTreatment, 'FACILITY');

  const gotoback = () => {
    navigate(`${patients}/${patientDetails}${mdsCommunication}`, {
      state: {
        patientId,
        patientData,
      },
    });
  };

  useEffect(() => {
    if (!patientId) return;
    dispatch(getMdsTypeAction(patientId));
  }, [patientId]);

  const handleCreateMds = (mdsData: MdsType) => {
    if (
      !reFormsMdsEnabled &&
      (preFillUrl.response === null || preFillUrl.loading || !preFillUrl.isGetFormId)
    )
      return;
    if (
      reFormsMdsEnabled &&
      (getMdsReformIdReducer === null ||
        getMdsReformIdReducer.loading ||
        !getMdsReformIdReducer.isGetMdsReformId)
    )
      return;
    navigate(`${patients}/${patientDetails}${mdsCommunication}${addMdsCommunication}`, {
      state: {
        patientId,
        patientData,
        mdsData,
      },
    });
  };

  return (
    <>
      <Grid
        container
        justifyContent={'space-between'}
      >
        <Stack gap="1.5rem">
          <Button
            sx={{
              justifyContent: 'flex-start',
              color: '#111927',
              width: 'max-content',
              padding: '0px',
            }}
            onClick={gotoback}
            startIcon={
              <SvgIcon>
                <ArrowBackIcon sx={{ color: '#6C737F' }} />
              </SvgIcon>
            }
          >
            <Typography variant="subtitle1">Back to MDS Assessment List</Typography>
          </Button>
        </Stack>
      </Grid>
      <Stack>
        {!getMdsTypeData.loading ? (
          <>
            {getMdsTypeData.response?.data?.data?.length !== 0 && getMdsTypeData.isGetType ? (
              <ListingTable
                items={getMdsTypeData.response?.data?.data}
                tableHead={[
                  { label: 'Assessment Type', value: 'assessmentType' },
                  { label: 'Assessment Date', value: 'assessmentDate' },
                  { label: '', value: 'plus', action: 'mds' },
                ]}
                isFromPagin={true}
                displayPagination={false}
                onCreate={handleCreateMds}
              />
            ) : (
              <Typography sx={{ margin: '1rem auto' }}>
                {getMdsTypeData.isGetType ? 'No Record Founds' : getMdsTypeData?.response?.message}
              </Typography>
            )}
          </>
        ) : (
          <>
            {Array(12)
              .fill(null)
              .map((_, index) => (
                <Skeleton key={index} />
              ))}
          </>
        )}
      </Stack>
    </>
  );
}

export default MdsCreateTable;
